import { MessageBar, MessageBarBody, MessageBarActions, Button } from '@fluentui/react-components';
import type { MessageBarIntent } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import React from 'react';

interface IOutageBannerProps {
  message: string;
  messageType?: MessageBarIntent;
  onDismiss?: () => void;
}

const OutageBanner = ({ message, messageType, onDismiss }: IOutageBannerProps): JSX.Element => {
  return (
    <MessageBar layout="multiline" intent={messageType ?? 'info'}>
      <MessageBarBody>{message}</MessageBarBody>
      {onDismiss && (
        <MessageBarActions
          containerAction={
            <Button
              appearance="transparent"
              icon={<DismissRegular />}
              onClick={onDismiss}
              aria-label="Dismiss banner"
              size="small"
            />
          }
        />
      )}
    </MessageBar>
  );
};

export default OutageBanner;
